import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, Newspaper } from 'lucide-react';

const News = () => {
  const newsItems = [
    {
      id: 1,
      title: 'New UK Gambling Regulations Take Effect in 2026',
      excerpt: 'The UK Gambling Commission announces stricter affordability checks and enhanced player protection measures starting January 2026.',
      date: '2025-11-29',
      slug: 'new-uk-gambling-regulations-2026',
      image: '/images/aceofnet-gTp5dGK6jtY-unsplash.webp'
    },
    {
      id: 2,
      title: 'Top 5 Casino Bonuses for December 2025',
      excerpt: 'We\'ve analyzed hundreds of offers to bring you the most valuable bonuses this month. See which casinos are offering the best deals.',
      date: '2025-11-25',
      slug: 'top-5-casino-bonuses-december-2025',
      image: '/images/aidan-howe-xrR-Kr2zppo-unsplash.webp'
    },
    {
      id: 3,
      title: 'How to Spot a Trustworthy Online Casino',
      excerpt: 'Learn the key indicators of a reliable casino platform: license verification, payment security, and player protection measures.',
      date: '2025-11-20',
      slug: 'how-to-spot-trustworthy-online-casino',
      image: '/images/amit-lahav-HffApi3okak-unsplash.webp'
    },
    {
      id: 4,
      title: 'UK Casino Industry Sees Record Growth in 2025',
      excerpt: 'Latest industry reports reveal unprecedented growth in online casino participation, with UK players spending more time and money than ever before.',
      date: '2025-11-15',
      slug: 'uk-casino-industry-record-growth-2025',
      image: '/images/eyestetix-studio-hdVQBey2LaI-unsplash.webp'
    },
    {
      id: 5,
      title: 'Payment Methods Revolutionizing UK Casino Withdrawals',
      excerpt: 'New instant withdrawal options are changing how UK players access winnings. Discover which methods offer fastest payouts and lowest fees.',
      date: '2025-11-10',
      slug: 'payment-methods-revolutionizing-uk-casino-withdrawals',
      image: '/images/jezael-melgoza-2xBb36ebevg-unsplash.webp'
    },
    {
      id: 6,
      title: 'Live Casino Games: The Future of Online Gaming',
      excerpt: 'Live dealer games are transforming UK online casino experiences. Explore how real-time streaming is bridging the gap between virtual and land-based casinos.',
      date: '2025-11-05',
      slug: 'live-casino-games-future-online-gaming',
      image: '/images/jonathan-petersson-W8V3G-Nk8FE-unsplash.webp'
    },
    {
      id: 7,
      title: 'Cryptocurrency Adoption in UK Online Casinos',
      excerpt: 'More UK casinos are accepting Bitcoin and other cryptocurrencies. Understand the benefits, risks, and practical implications of crypto gambling.',
      date: '2025-10-30',
      slug: 'cryptocurrency-adoption-uk-online-casinos',
      image: '/images/michal-parzuchowski-bRqsXcEcKFw-unsplash.webp'
    },
    {
      id: 8,
      title: 'Slot Game Innovations: What\'s New in 2025',
      excerpt: 'Game developers are pushing boundaries with innovative slot mechanics, bonus features, and graphics. See the latest trends shaping slot gaming.',
      date: '2025-10-25',
      slug: 'slot-game-innovations-whats-new-2025',
      image: '/images/michal-parzuchowski-pvIVPYGM16o-unsplash.webp'
    },
    {
      id: 9,
      title: 'Responsible Gambling: New Tools for UK Players',
      excerpt: 'Enhanced responsible gambling features are helping UK players maintain control. Learn about new tools, limits, and support resources available.',
      date: '2025-10-20',
      slug: 'responsible-gambling-new-tools-uk-players',
      image: '/images/nejc-soklic-3UiIsHadyJw-unsplash.webp'
    }
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  return (
    <div className="min-h-screen bg-regal-dark">
      <Header />
      <main className="py-12 md:py-20">
        <div className="container mx-auto px-4">
          {/* Hero Section */}
          <div className="text-center mb-16 max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white">
              UK Casino News & Industry Updates
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed">
              Stay ahead of the curve with breaking news, industry insights, and expert analysis of the UK online casino landscape.
            </p>
          </div>

          {/* News Grid */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {newsItems.map((item) => (
              <article
                key={item.id}
                itemScope
                itemType="https://schema.org/NewsArticle"
                className="bg-regal-gray rounded-xl overflow-hidden border border-gray-800 hover:border-regal-red transition-all"
              >
                <div className="h-48 relative overflow-hidden">
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="w-full h-full object-cover"
                    itemprop="image"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 text-gray-400 text-sm mb-3">
                    <Calendar size={16} />
                    <time dateTime={item.date} itemprop="datePublished">{formatDate(item.date)}</time>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3 leading-tight" itemprop="headline">
                    {item.title}
                  </h3>
                  <p className="text-gray-300 mb-4 leading-relaxed" itemprop="description">
                    {item.excerpt}
                  </p>
                  <Link
                    to={`/news/${item.slug}`}
                    data-discover="true"
                    className="inline-flex items-center gap-2 text-regal-red hover:text-red-400 font-semibold transition-colors"
                    itemprop="url"
                  >
                    Read More
                    <ArrowRight size={16} />
                  </Link>
                </div>
              </article>
            ))}
          </div>

          {/* How We Choose News Section */}
          <div className="bg-regal-gray rounded-xl p-8 md:p-12 border border-gray-800">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center gap-4 mb-8">
                <Newspaper className="w-12 h-12 text-regal-red" />
                <h2 className="text-3xl md:text-4xl font-bold text-white">
                  How We Choose Our News
                </h2>
              </div>
              <div className="space-y-6 text-gray-300 leading-relaxed text-lg">
                <p>
                  In the fast-paced world of UK online casinos, news breaks constantly—but not all of it matters to players. Our editorial process filters through hundreds of industry updates, regulatory announcements, and market developments to bring you stories that actually impact your gaming experience. We don't chase clicks or publish press releases verbatim. Instead, we analyze, verify, and contextualize news to deliver value you can't find elsewhere.
                </p>
                <p>
                  Regulatory changes take priority in our selection process because they directly affect how UK players interact with online casinos. When the UK Gambling Commission announces new rules, we don't just report the headlines—we break down what these changes mean for your accounts, withdrawals, bonuses, and gameplay. We translate legal language into practical implications, helping you understand how regulatory shifts affect your casino experience before others even realize changes are coming.
                </p>
                <p>
                  Industry trends matter when they signal shifts in how casinos operate or what players can expect. We monitor patterns across multiple operators, identifying developments that indicate broader industry movements rather than isolated incidents. A single casino's new payment method might not warrant coverage, but widespread adoption of instant withdrawals or cryptocurrency acceptance does. We spot these trends early and explain what they mean for your future gaming options.
                </p>
                <p>
                  Player impact drives every news selection decision. Stories that help you make better choices, avoid problems, or understand opportunities get priority. Technical updates that don't affect gameplay or user experience rarely make the cut unless they enable significant improvements. We ask ourselves: does this news help players, warn players, or inform players? If the answer is no, we skip it regardless of how much industry buzz it generates.
                </p>
                <p>
                  Verification separates our news from rumor mills and unverified speculation. We cross-reference multiple sources, verify claims with original documents, and consult industry experts before publishing. Regulatory announcements come from official sources. Casino updates are confirmed directly with operators or through verifiable public statements. We never rely on anonymous tips or unconfirmed reports—accuracy matters more than being first with breaking news.
                </p>
                <p>
                  Timeliness balances with thoroughness in our editorial approach. While we move quickly on breaking regulatory news or urgent player warnings, we take time to fully understand developments before publishing comprehensive coverage. A rushed article with half-facts helps nobody. Better to wait a day and deliver complete, accurate information than to be first with incomplete details that require corrections later.
                </p>
                <p>
                  Original analysis distinguishes our coverage from news aggregation. Anyone can compile press releases—we go further by analyzing what developments mean for UK players specifically. We consider historical context, compare similar situations, and predict likely outcomes based on industry patterns. This depth helps you understand not just what's happening, but why it matters and how it might affect your casino experiences moving forward.
                </p>
                <p>
                  Our news selection prioritizes actionable intelligence over entertainment. We want you to finish reading articles with clear understanding of developments and practical knowledge about how to respond. Whether it's adapting to new regulations, taking advantage of industry changes, or avoiding problems revealed through our coverage, every news item should leave you better informed and better equipped to navigate the UK casino landscape.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default News;
